(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-order-whatsapp"] && !Shopify.designMode) return;
  try {
    
  class CustomOrderSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.slides = [...this.querySelectorAll('.custom-order-whatsapp__slide')];
      this.dotsWrap = this.querySelector('[data-dots]');
      this.prevBtn = this.querySelector('[data-prev]');
      this.nextBtn = this.querySelector('[data-next]');
      this.index = 0;
      this.autoplay = this.dataset.autoplay === 'true';
      this.interval = Number(this.dataset.interval || 4000);
      this.timer = null;
      this.touchStartX = 0;
      this.touchDeltaX = 0;

      if (!this.track || this.slides.length === 0) return;

      this.buildDots();
      this.prevBtn?.addEventListener('click', () => this.go(this.index - 1));
      this.nextBtn?.addEventListener('click', () => this.go(this.index + 1));
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());
      this.addEventListener('touchstart', (e) => this.onTouchStart(e), { passive: true });
      this.addEventListener('touchmove', (e) => this.onTouchMove(e), { passive: true });
      this.addEventListener('touchend', () => this.onTouchEnd());
      this.render();
      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    buildDots() {
      if (!this.dotsWrap || this.slides.length < 2) return;
      this.dotsWrap.innerHTML = '';
      this.slides.forEach((_, i) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'custom-order-whatsapp__dot';
        btn.setAttribute('aria-label', `Slide ${i + 1}`);
        btn.addEventListener('click', () => this.go(i));
        this.dotsWrap.appendChild(btn);
      });
      this.dots = [...this.dotsWrap.querySelectorAll('.custom-order-whatsapp__dot')];
    }

    go(i) {
      const total = this.slides.length;
      this.index = ((i % total) + total) % total;
      this.render();
      this.start();
    }

    render() {
      this.track.style.transform = `translate3d(-${this.index * 100}%, 0, 0)`;
      this.dots?.forEach((dot, i) => {
        if (i === this.index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }

    onTouchStart(e) {
      this.touchStartX = e.changedTouches[0].clientX;
      this.touchDeltaX = 0;
      this.stop();
    }

    onTouchMove(e) {
      this.touchDeltaX = e.changedTouches[0].clientX - this.touchStartX;
    }

    onTouchEnd() {
      if (Math.abs(this.touchDeltaX) > 40) {
        this.go(this.index + (this.touchDeltaX < 0 ? 1 : -1));
      } else {
        this.start();
      }
    }

    start() {
      this.stop();
      if (!this.autoplay || this.slides.length < 2) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.timer = window.setInterval(() => this.go(this.index + 1), this.interval);
    }

    stop() {
      if (this.timer) window.clearInterval(this.timer);
      this.timer = null;
    }
  }

  if (!customElements.get('custom-order-slider')) {
    customElements.define('custom-order-slider', CustomOrderSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vultaro-faq"] && !Shopify.designMode) return;
  try {
    
  class VultaroFaqList extends HTMLElement {
    connectedCallback() {
      this.singleOpen = this.dataset.singleOpen !== 'false';
      this.items = [...this.querySelectorAll('.vultaro-faq__item')];
      if (!this.singleOpen || this.items.length < 2) return;

      this.items.forEach((item) => {
        item.addEventListener('toggle', () => {
          if (!item.open) return;
          this.items.forEach((other) => {
            if (other !== item && other.open) other.open = false;
          });
        });
      });
    }
  }

  // Attach behavior to the list wrapper via MutationObserver-free bind
  document.querySelectorAll('[data-faq-list]').forEach((list) => {
    if (list.dataset.bound === 'true') return;
    list.dataset.bound = 'true';
    const singleOpen = list.dataset.singleOpen !== 'false';
    const items = [...list.querySelectorAll('.vultaro-faq__item')];
    if (!singleOpen || items.length < 2) return;
    items.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        items.forEach((other) => {
          if (other !== item && other.open) other.open = false;
        });
      });
    });
  });

  if (!customElements.get('vultaro-faq-list')) {
    customElements.define('vultaro-faq-list', VultaroFaqList);
  }

  } catch(e) { console.error(e); }
})();
})();
